export enum SyncStatus {
  Closed = 'closed',
  NeedsRenewal = 'needsRenewal',
  Realtime = 'realtime',
  Synced = 'synced',
  ConnectionDeleted = 'connectionDeleted',
  OfflineData = 'offlineData',
}
